function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from 'react';
import IconButton from "noood/comp/button/IconButton";
import { FormFieldCollectorContext } from "../Form";
import { form_validator } from "../FormFieldValidator";
import PropTypes from 'prop-types';
import SpinnerApple from "noood/comp/ui/spinner/Spinner.Apple";
export default function TextFieldMultiValue(props) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    values = _useState2[0],
    set_values = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    input_value = _useState4[0],
    set_input_value = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    suggestions = _useState6[0],
    set_suggestions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    suggesting = _useState8[0],
    set_suggesting = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    suggestion_timer = _useState0[0],
    set_suggestion_timer = _useState0[1];
  var collector = useContext(FormFieldCollectorContext);
  useEffect(function () {
    set_values(props.value);
  }, [props.value]);
  useEffect(function () {
    collector(values, props.name, form_validator.validate(props.validations, values));
  }, [values]);
  function __suggest(val) {
    if (val.length > 0 && props.__suggest) {
      set_suggesting(true);
      set_suggestions([]);
      if (suggestion_timer != null) {
        clearTimeout(suggestion_timer);
      }
      set_suggestion_timer(setTimeout(function () {
        if (val.length > 0) {
          props.__suggest(val, function (list) {
            if (list && list.length > 0) {
              set_suggestions(list);
              set_suggesting(false);
            } else {
              set_suggestions([]);
              set_suggesting(false);
            }
          });
        } else {
          set_suggestions([]);
          set_suggesting(false);
        }
      }, 500));
    } else {
      set_suggestions([]);
      set_suggesting(false);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label), /*#__PURE__*/React.createElement("div", {
    className: 'textfield_multi_box',
    style: {
      backgroundColor: '#f7f7f7',
      padding: '3px',
      verticalAlign: 'top'
    }
  }, /*#__PURE__*/React.createElement("ol", {
    className: 'textfield_multi_ol'
  }, values && Array.isArray(values) && values.length > 0 ? values.map(function (val, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      key: idx,
      style: {
        backgroundColor: '#ccc',
        padding: '2px 6px',
        margin: '3px',
        clear: 'both',
        display: 'table'
      }
    }, /*#__PURE__*/React.createElement("table", {
      className: "collapsed"
    }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, val), /*#__PURE__*/React.createElement("td", {
      style: {
        paddingLeft: "8px"
      }
    }, /*#__PURE__*/React.createElement(FormFieldCollectorContext.Consumer, null, function (collector) {
      return /*#__PURE__*/React.createElement(IconButton, {
        feather_icon_class: 'x',
        __click: function __click() {
          var new_array = _toConsumableArray(values);
          new_array.splice(idx, 1);
          set_values(new_array);
        }
      });
    })))))));
  }) : null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '25px',
      display: 'inline-block'
    }
  }, /*#__PURE__*/React.createElement(FormFieldCollectorContext.Consumer, null, function (collector) {
    return /*#__PURE__*/React.createElement("input", {
      style: {
        marginLeft: '5px',
        width: '200px',
        padding: '0'
      },
      placeholder: props.placeholder,
      value: input_value,
      onChange: function onChange(e) {
        set_input_value(e.currentTarget.value);
        __suggest(e.currentTarget.value);
        return false;
      },
      onKeyDown: function onKeyDown(e) {
        set_input_value(e.currentTarget.value);
        if (e.keyCode === 13) {
          // Enter key
          if (e.currentTarget.value && e.currentTarget.value.trim().length > 0) {
            var new_values = values === void 0 ? [] : _toConsumableArray(values);
            new_values.push(e.currentTarget.value.trim());
            set_values(new_values);
            set_input_value('');
            collector(new_values, props.name, []);
          }
        }
        return false;
      }
    });
  })), suggesting ? /*#__PURE__*/React.createElement("div", {
    className: "textfield_multi_suggesting"
  }, /*#__PURE__*/React.createElement(SpinnerApple, null)) : null, suggestions && Array.isArray(suggestions) && suggestions.length > 0 ? /*#__PURE__*/React.createElement(FormFieldCollectorContext.Consumer, null, function (collector) {
    return /*#__PURE__*/React.createElement("div", {
      className: 'textfield_multi_suggest_box'
    }, suggestions.map(function (suggestion, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        onClick: function onClick() {
          var new_values = values !== null && values !== void 0 ? values : [];
          new_values.push(suggestion.value);
          set_values(new_values);
          set_suggestions([]);
          set_input_value('');
          collector(new_values, props.name, []);
        }
      }, suggestion.value);
    }));
  }) : null))), props.caption ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '10px'
    },
    className: "text-caption"
  }, props.caption) : null);
}
TextFieldMultiValue.propTypes = {
  value: PropTypes.array,
  name: PropTypes.string,
  __suggest: PropTypes.func
};